import { styled } from "@mui/material/styles";

import { MainColumnWrapper } from "../components/MainColumnWrapper";

type ContainerSectionProps = { constraindWidth?: boolean; children: React.ReactNode };

export function ProductFullWrapper(props: ContainerSectionProps) {
    const { constraindWidth = true, children } = props;

    if (constraindWidth) {
        return <MainColumnWrapper>{children}</MainColumnWrapper>;
    }

    return <div>{children}</div>;
}

export type ProductMainLayoutMode = "default" | "content-below-gallery-and-availability";

export const ProductFullMainLayout = styled("div")<{ layoutMode: ProductMainLayoutMode }>(({ theme, layoutMode }) => ({
    display: "grid",
    marginTop: theme.spacing(2),
    [theme.breakpoints.up("lg")]: {
        gridTemplateAreas:
            layoutMode === "content-below-gallery-and-availability"
                ? '"gallery side" "content content"'
                : '"gallery side" "content side"',
        gap: theme.spacing(3, 2),
        gridTemplateColumns: "auto 430px",
    },
    [theme.breakpoints.down("lg")]: {
        gridTemplateAreas: '"gallery" "side" "content"',
        gridTemplateColumns: "minmax(0, 1fr)",
        gap: theme.spacing(2),
    },
}));

export const ProductFullGalleryWrapper = styled("div")({
    gridArea: "gallery",
});

export const ProductFullSideContentWrapper = styled("div")({
    gridArea: "side",
});

export const ProductFullSideContentStyled = styled("div")({
    position: "sticky",
    top: 170,
});

export const ProductFullMainContentWrapper = styled("div")({ gridArea: "content" });
